@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.new-pill {
  display: inline-flex;
  align-items: center;

  height: 24px;
  min-width: 20px;
  padding: 0 @space-8;

  border-radius: var(--Radius-XL, @space-32);
  background: var(--Upgrade-Medium);

  color: var(--white);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: @space-16;
}
